var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isLoading)?_c('router-view'):_c('h2',{attrs:{"align":"center"}},[_vm._v("404 - Something went terribly wrong!")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }